import {
  Button,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  VStack,
} from "@chakra-ui/react";
import { useGlobalContext } from "./GlobalState";
import { useSigninService } from "../Services/SigninService";
import { useEffect, useState } from "react";

export function Login() {
  const globalContext = useGlobalContext();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const signinService = useSigninService();

  return (
    <>
      <Button
        hidden={globalContext.authorizedAs != null}
        onClick={() => {
          signinService.checkSigninStatus().then((wasActuallySignedIn) => {
            if (wasActuallySignedIn) {
              setShowLoginModal(false);
            } else {
              setShowLoginModal(true);
            }
          });
        }}
        variant={"outline"}
        textColor={"white"}
        _hover={{
          textColor: "black",
          background: "gray.300",
        }}
        _active={{
          textColor: "black",
        }}
      >
        {"Logga in"}
      </Button>

      <Button
        hidden={globalContext.authorizedAs === undefined}
        onClick={signinService.signout}
        variant={"ghost"}
        textColor={"red"}
        _hover={{
          textColor: "black",
          background: "gray.300",
        }}
        _active={{
          textColor: "black",
        }}
      >
        {"Logga ut"}
      </Button>

      <LoginModal
        open={showLoginModal}
        onClose={(
          attemptLogin: boolean,
          username: string,
          password: string
        ) => {
          setShowLoginModal(false);
          if (attemptLogin) {
            signinService.signin(username, password);
          }
        }}
      />
    </>
  );
}

export const LoginModal = (props: {
  open: boolean;
  onClose: (attemptLogin: boolean, username: string, password: string) => void;
}) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  return (
    <Modal
      isOpen={props.open}
      onClose={() => props.onClose(false, username, password)}
    >
      <ModalOverlay />
      <ModalContent minW={"450px"} height={"fit-content"} width={"fit-content"}>
        <ModalHeader fontSize={"x-large"} alignSelf={"center"}>
          Logga in
        </ModalHeader>
        <ModalCloseButton
          onClick={() => {
            props.onClose(false, username, password);
          }}
        />
        <ModalBody padding={"40px"}>
          <VStack align={"left"} spacing={3}>
            <Heading size={"sm"}>Username</Heading>
            <Input
              onChange={(event) => {
                setUsername(event.target.value);
              }}
            />
            <Heading size={"sm"}>Password</Heading>
            <Input
              type="password"
              onChange={(event) => {
                setPassword(event.target.value);
              }}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Spacer />{" "}
          <Button
            isDisabled={username.length === 0 || password.length === 0}
            onClick={() => {
              props.onClose(true, username, password);
            }}
            width={"50%"}
            colorScheme="green"
          >
            Login
          </Button>{" "}
          <Spacer />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
